import {
  CreatePatientInput,
  CreatePsiInput,
  CreatePsiResult,
  CreateUserInput,
  UpdateUserInput,
} from "@/domain/dtos/inputs";
import {
  PatientHomeInfo,
  PsiDetail,
  UserHomeInfo,
  UserPatient,
  UserPsi,
} from "../../domain/entities";
import { UserMapper } from "../../domain/mappers";
import { UserRepository } from "../../domain/repositories";
import { UserDataSource } from "../datasources/user";
import { CreateUserRequest } from "../dtos/requests";
import { UserHomeInfoResponse, UserResponse } from "../dtos/responses";

export class UserRepoImpl implements UserRepository {
  constructor(
    private readonly dataSource: UserDataSource,
    private readonly userMapper: UserMapper<
      UserResponse,
      UserHomeInfoResponse,
      CreateUserRequest
    >,
  ) {}
  async getUserHomeInfo(): Promise<UserHomeInfo> {
    const data = await this.dataSource.getUserHomeInfo();

    return this.userMapper.toHomeInfo(data);
  }
  async getPatientHomeInfo(): Promise<PatientHomeInfo> {
    const data = await this.dataSource.getUserHomeInfo();

    return this.userMapper.toPatientHomeInfo(data);
  }
  async getUserById(id: number): Promise<UserPsi> {
    const data = await this.dataSource.getUserById(id);

    return this.userMapper.toDomain(data);
  }
  async getUserBySlug(slug: string): Promise<UserPsi> {
    const data = await this.dataSource.getUserBySlug(slug);

    return this.userMapper.toDomain(data);
  }
  async getPsiDetailById(id: number): Promise<UserPsi> {
    const data = await this.dataSource.getUserById(id);

    return this.userMapper.toDomain(data);
  }
  async getPsiDetailBySlug(slug: string): Promise<UserPsi> {
    const data = await this.dataSource.getUserBySlug(slug);

    return this.userMapper.toDomain(data);
  }
  async getPatientById(id: number): Promise<UserPatient> {
    const data = await this.dataSource.getUserById(id);

    return this.userMapper.toPatientDomain(data);
  }
  async updateUser(
    id: number,
    params: Partial<UpdateUserInput>,
  ): Promise<UserPsi> {
    const data = await this.dataSource.updateUser(id, params);

    return this.userMapper.toDomain(data);
  }

  async createPsi(params: CreatePsiInput): Promise<UserPsi> {
    const request = this.userMapper.toCreatePsi(params);
    const data = await this.dataSource.createUser(request);
    return this.userMapper.toDomain(data);
  }

  // depreciada
  async createUser(params: CreateUserInput): Promise<UserPsi> {
    const request = this.userMapper.toCreateRequest(params);
    const data = await this.dataSource.createUser(request);
    return this.userMapper.toDomain(data);
  }

  async deleteUser(id: number): Promise<{ message: string }> {
    const { message } = await this.dataSource.deleteUser(id);
    return {
      message:
        message || "Todas as suas informações foram deletadas com sucesso.",
    };
  }

  async checkIfEmailAlreadyExists(params: {
    email: string;
  }): Promise<{ registered: boolean }> {
    const { registered } = await this.dataSource.checkIfEmailAlreadyExists({
      email: params.email,
    });
    return { registered };
  }

  async createPatient(params: CreatePatientInput): Promise<UserPatient> {
    const request = this.userMapper.toCreatePatient(params);
    const data = await this.dataSource.createUser(request);
    return this.userMapper.toPatientDomain(data);
  }

  async findPsis(params: {
    search?: string;
    page?: number;
    seed?: number;
  }): Promise<{
    psis: UserPsi[];
    total: number;
  }> {
    const { psis, total } = await this.dataSource.findPsis(params);
    return {
      psis: psis.map((elem) => this.userMapper.toDomain(elem)),
      total,
    };
  }
}
